module.exports = __webpack_public_path__ + "static/media/hospitalMedical.965afbda.svg";